import CookieList from './CookieList';

export default class ProductListService {
	#cookieList;
	#addListeners;
	#removeListeners;

	constructor(name) {
		this.#cookieList = new CookieList(name);
		this.#addListeners = [];
		this.#removeListeners = [];
	}

	addListenerAdd(listener) {
		this.#addListeners.push(listener);
	}

	addListenerRemove(listener) {
		this.#removeListeners.push(listener);
	}

	add(product, callListeners = true) {
		this.#cookieList.add(product.id);

		if (callListeners) {
			this.#addListeners.forEach(listener => listener(product));
		}
	}

	remove(product, callListeners = true) {
		this.#cookieList.remove(product.id);

		if (callListeners) {
			this.#removeListeners.forEach(listener => listener(product));
		}
	}

	count() {
		return this.#cookieList.count();
	}
}
